module.exports = __webpack_public_path__ + "img/senior2.7db4e9c6.png";